import { createDraftSafeSelector } from '@reduxjs/toolkit';

const selectSelf = (state: RootState) => state.auctionsBids;

const bidDataSelector = createDraftSafeSelector(selectSelf, (state) => state.bidData);
const rapPriceSelector = createDraftSafeSelector(selectSelf, (state) => state.rapPrice);
const rapUpdatedSelector = createDraftSafeSelector(selectSelf, (state) => state.rapUpdatedDate);

const auctionBidsSelector = createDraftSafeSelector(
  bidDataSelector,
  rapPriceSelector,
  rapUpdatedSelector,
  (bidData, rapPrice, rapUpdatedDate) => {
    const leadBidRapDiff = !bidData.lead_bid || !rapPrice ? null : 1 - bidData.lead_bid / rapPrice;
    const nextBidRapDiff = !bidData.next_bid || !rapPrice ? null : 1 - bidData.next_bid / rapPrice;

    return {
      reserved_price_met: false,
      lead_bid: null,
      your_bid: null,
      next_bid: null,
      is_bid_pending: false,
      leadBidRapDiff,
      nextBidRapDiff,
      rapPrice,
      rapUpdatedDate,
      ...bidData,
    };
  },
);

const showBidPlacedToast = createDraftSafeSelector(selectSelf, (state) => state.showBidPlacedToast);

export const auctionsBidsSelectors = {
  auctionBidsSelector,
  showBidPlacedToast,
};
